import { AxiosError } from "axios";

export const isNetworkError = (error) => {
  return error instanceof AxiosError && error.code === "ERR_NETWORK";
};
